var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    ref: "scrollBox",
    staticClass: "main explore-content-v3"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "explore-content-v3-box clearfix2"
  }, [_c('div', {
    staticClass: "explore-content-v3-box-left",
    attrs: {
      "id": "leftnav"
    }
  }, [_c('ul', {
    staticClass: "box-left-nav clearfix2"
  }, _vm._l(_vm.navs, function (nav, index) {
    return _c('li', {
      key: index,
      staticClass: "nav",
      class: [_vm.activedNav.key == nav.key ? 'active' : '', nav.icon],
      on: {
        "click": function click($event) {
          return _vm.navClickHandler(nav);
        }
      }
    }, [_vm._v(_vm._s(nav.title))]);
  }), 0), _vm._v(" "), _vm.showDownload === true ? _c('boxLeftLink') : _vm._e()], 1), _vm._v(" "), !_vm.jmt ? _c('div', {
    staticClass: "explore-content-v3-box-right",
    attrs: {
      "id": "scroll"
    }
  }, [!_vm.isUS() && _vm.activedNav.key === 'global' ? _c('globalFilterBar', {
    attrs: {
      "title": _vm.globalFilterTitle,
      "filters": _vm.country_list
    },
    on: {
      "select": _vm.globalFilterSelectHandler
    }
  }) : _vm._e(), _vm._v(" "), !_vm.isUS() && _vm.activedNav.key !== 'global' ? _c('filterBar', {
    attrs: {
      "title": _vm.getFilterBarTitle(),
      "filters": _vm.getFilters()
    },
    on: {
      "select": _vm.filterSelectHandler
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list-wrap clearfix2"
  }, [_c('div', {
    staticClass: "page-live-video-list"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('liveVideoList', {
      key: index,
      attrs: {
        "cover": item.videocapture,
        "heat": item.heat,
        "desc": item.title,
        "nickname": item.uname,
        "vdoid": item.vdoid
      }
    });
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.run,
      expression: "run"
    }],
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loader"
  })]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showNoData,
      expression: "showNoData"
    }],
    staticClass: "no-data"
  }, [_vm._v(_vm._s(_vm.$t("noMoreTryAgain")))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showLoadMore && !_vm.run,
      expression: "showLoadMore && !run"
    }],
    staticClass: "more-data"
  }, [_c('span', {
    on: {
      "click": function click($event) {
        return _vm.loadMoreClickHandler();
      }
    }
  }, [_vm._v("\n                             " + _vm._s(_vm.$t("loadMore")))])])])], 1) : _vm._e(), _vm._v(" "), _vm.jmt ? _c('div', {
    staticClass: "explore-content-v3-box-right"
  }, [_c('jieMeitao')], 1) : _vm._e()])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };